<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showClient") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badges ==== -->
      <div class="badges_wrapper justify-content-center">
        <v-chip :color="data.active ? 'green' : 'red'" text-color="white">
          {{ data.active ? $t("STATUS.active") : $t("STATUS.notActive") }}
        </v-chip>
      </div>
      <!-- ==== End:: Status Badges ==== -->

      <!-- ==== Start:: Client Main Data ==== -->
      <form>
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <div v-if="data.avatar" class="col-12">
            <!-- Display image -->
            <div class="preview-container text-center my-3">
              <img :src="data.avatar" alt="Client Avatar" />
            </div>
          </div>
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
            disabled
            class="disabled_input"
          />
          <!-- End:: Name Input -->

          <!-- Start:: Phone Input -->
          <base-input
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.mobile"
            readonly
            class="disabled_input"
          />
          <!-- End:: Phone Input -->

          <!-- Start:: City Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city"
            readonly
            class="disabled_input"
          />
          <!-- End:: City Input -->

          <!-- Start:: Email Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            readonly
            class="disabled_input"
          />
          <!-- End:: Email Input -->

          <!-- Start:: Location on Map -->
          <div class="map_wrapper">
            <GmapMap
              :center="{
                lat: parseFloat(data.lat),
                lng: parseFloat(data.lng),
              }"
              :zoom="13"
              map-type-id="terrain"
              style="width: 100%; height: 500px"
            >
              <GmapMarker
                :position="{lat : data.lat , lng: data.lng}"
                :clickable="false"
                :draggable="false"
                @click="center = m.position"
              />
            </GmapMap>
          </div>
          <!-- End:: Location on Map -->

          <!-- Start:: Interests Input -->
          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.interests')"
            v-model.trim="data.interests"
            readonly
            class="disabled_input"
          />
          <!-- End:: Interests Input -->
        </div>
      </form>
      <!-- ==== End:: Client Main Data ==== -->
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "SingleClient",

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Loading Data
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Table Data
      addressesTableHeaders: [
        { text: this.$t("TABLES.Addresses.serialNumber") },
        { text: this.$t("TABLES.Addresses.address") },
        { text: this.$t("TABLES.Addresses.longitude") },
        { text: this.$t("TABLES.Addresses.latitude") },
        { text: this.$t("TABLES.Addresses.type") },
        { text: this.$t("TABLES.Addresses.isDefault") },
      ],
      // End:: Table Data

      // Start:: Data
      data: {
        id: null,
        name: null,
        email: null,
        mobile: null,
        city: null,
        latitude: null,
        longitude: null,
        interests: null,
        is_active: null,
        avatar: null,
        lat: 30.0444, // Default coordinates for map center
        lng: 30.0444,
        active: false,
      },
      // End:: Data
    };
  },

  methods: {
    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `clients/${this.$route.params.id}`,
        });
        console.log("DATA =>", res.data.data);

        // Map API response to component data
        const userData = res.data.data.client;
        this.data.id = userData.id;
        this.data.name = userData.name;
        this.data.email = userData.email;
        this.data.mobile = userData.mobile;
        this.data.is_active = userData.is_active;
        this.data.avatar = userData.avatar;
        this.data.active = userData.is_active;

        // Handle optional fields - these might not be in the API response yet
        this.data.city = userData.city || this.$t("PLACEHOLDERS.no_city");
        this.data.latitude = userData.latitude || null;
        this.data.longitude = userData.longitude || null;
        this.data.interests =
          userData.interests?.map((ele)=>(ele.name))?.join(", ") || this.$t("PLACEHOLDERS.no_interests");

        // Handle null email
        if (!this.data.email) {
          this.data.email = this.$t("PLACEHOLDERS.no_email");
        }

        // Initialize map if coordinates are available
        if (this.data.latitude && this.data.longitude) {
          this.$nextTick(() => {
            this.initializeMap();
          });
        }
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    // Start:: Initialize Google Map
    initializeMap() {
      const mapOptions = {
        center: {
          lat: parseFloat(this.data.latitude),
          lng: parseFloat(this.data.longitude),
        },
        zoom: 15,
      };

      const map = new google.maps.Map(
        document.getElementById("map"),
        mapOptions
      );

      // Add marker
      new google.maps.Marker({
        position: {
          lat: parseFloat(this.data.latitude),
          lng: parseFloat(this.data.longitude),
        },
        map: map,
        title: this.data.name,
      });
    },
    // End:: Get Data To Show
  },

  created() {
    // Start:: Fire Methods
    this.getDataToShow();
    // End:: Fire Methods
  },
};
</script>
<style>
.preview-container img {
  max-width: 150px;
  max-height: 150px;
  border: 2px solid #ddd;
  border-radius: 50%;
  object-fit: cover;
}

.badges_wrapper {
  margin-bottom: 20px;
}

#map {
  border: 1px solid #ddd;
  border-radius: 8px;
}

.form-label {
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  display: block;
}
</style>
